import React from 'react';
import { Button } from 'antd';
import { ArrowRightIcon } from '@gtintel/platform-atoms';
const NextButton = props => {
  return <Button data-public {...props} data-testid="next-button">
      Next <ArrowRightIcon />
    </Button>;
};
export default NextButton;